import { useCallback, useEffect, useMemo } from 'react';

const useContentProtection = ({
  disableContextMenu = true,
  disableSelection = true,
  disablePrint = true,
} = {}) => {
  useEffect(() => {
    const blockCapture = (e) => {
      if (
        e.key === 'PrintScreen' ||
        (e.ctrlKey && (e.key === 'p' || e.key === 'P')) ||
        (e.metaKey && (e.key === 'p' || e.key === 'P')) ||
        (e.ctrlKey && (e.key === 's' || e.key === 'S')) ||
        (e.metaKey && (e.key === 's' || e.key === 'S'))
      ) {
        e.preventDefault();
        e.stopPropagation();
      }
    };

    document.addEventListener('keydown', blockCapture);
    return () => document.removeEventListener('keydown', blockCapture);
  }, []);

  const onContextMenu = useCallback(
    (e) => {
      if (disableContextMenu) {
        e.preventDefault();
      }
    },
    [disableContextMenu]
  );

  const protectionSx = useMemo(
    () => ({
      ...(disableSelection
        ? {
            userSelect: 'none',
            WebkitUserSelect: 'none',
            MozUserSelect: 'none',
            msUserSelect: 'none',
          }
        : {}),
      ...(disablePrint ? { '@media print': { display: 'none' } } : {}),
    }),
    [disablePrint, disableSelection]
  );

  return { onContextMenu, protectionSx };
};

export default useContentProtection;